import { Entity } from '@backstage/catalog-model';
import { createApiRef } from '@backstage/core-plugin-api';
import {
  BulkMaturityScore,
  BulkMaturitySummary,
  MaturityRank,
  MaturityScore,
  MaturitySummary,
} from '../types';

export const scoringDataApiRef = createApiRef<ScoringDataApi>({
  id: 'plugin.scoringdata.service',
});

export type ScoringDataApi = {
  getMaturityRank(entity: Entity): Promise<MaturityRank>;
  getMaturityScore(entity: Entity): Promise<MaturityScore>;
  getBulkMaturityScores(entity: Entity): Promise<BulkMaturityScore>;
  getMaturitySummary(entity: Entity): Promise<MaturitySummary>;
  getBulkMaturitySummary(entity: Entity): Promise<BulkMaturitySummary>;
};
